// src/pages/RulesPage.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Shield, FileText, Building2, Info } from 'lucide-react';

const RulesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 rtl pb-16">
      

      {/* محتوا */}
      <div className="container mx-auto px-4 py-6">
        <div className="bg-white rounded-xl p-6">
        
          <div className="space-y-6">
            {/* ✅ بخش جدید: معرفی موسسه */}
            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 flex gap-3 items-start">
              <Building2 size={28} className="text-indigo-700 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-bold text-indigo-800 mb-1">درباره‌یِ وب‌اپلیکیشین فرزانه
</h3>
                <p className="text-gray-700 text-[11px] leading-relaxed text-justify">
                  مؤسسه‌یِ فرزانه (با نام ثبتی «مؤسسه‌یِ چهره‌یِ فرزانه‌یِ روز» و شماره‌یِ ثبت ۴۷۱۴۷)
                   با هدف گردآوری، تنظیم، و نشر آثار مصطفی ملکیان شکل گرفته‌ است. این وب‌اپلیکیشن
                    با هدف تسهیل دست‌رسی فارسی‌دانان به محتوای بروز، و باکیفیت، تحت نظر مصطفی ملکیان 
                   ایجاد شده است و به عرضه‌یِ آثار صوتی، تصویری، و مکتوب، براساس نظام فکری ارائه‌شده 
                   از سوی شخص ایشان، میپردازد. هدف ما این است که بتدریج آرشیو کامل آثار مصطفی ملکیان را 
                   در این وب‌اپلیکیشن گردآوری کرده و عرضه کنیم؛ راه‌نمایی نظاممند برای زندگی بهروزانه‌.
                </p>
              </div>
            </div>

            <section>
              <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2 mb-3">
                <FileText size={20} /> اصول اخلاقی
              </h2>
              <ul className="list-disc pr-5 space-y-2 text-gray-700 text-[11px]">
                <li>احترام به حریم خصوصی کاربران و حفظ اطلاعات شخصی.</li>
                <li>ارائه محتوای معتبر، علمی و منطبق با ارزش‌های فرهنگی جامعه.</li>
                <li>پرهیز از هرگونه توهین، تبعیض یا محتوای خلاف قوانین جمهوری اسلامی ایران.</li>
                <li>شفافیت در فرآیند خرید، فروش و دریافت کمک‌های مالی.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">قوانین استفاده از اپلیکیشن</h2>
              <ol className="list-decimal pr-5 space-y-2 text-gray-700 text-[11px]">
                <li>کاربران موظف به رعایت قوانین جاری کشور و حقوق مالکیت فکری هستند.</li>
                <li>هرگونه سوءاستفاده از محتوا (توزیع غیرمجاز، کپی‌برداری تجاری) ممنوع بوده و پیگرد قانونی دارد.</li>
                <li>دسترسی به محصولات خریداری شده، صرفاً برای کاربر خریدار و با ورود به حساب کاربری خودش امکان‌پذیر است.</li>
                <li>اپلیکیشن فرزانه در قبال مشکلات فنی احتمالی یا از دست رفتن موقت داده‌ها، حداکثر تلاش خود را برای بازیابی انجام می‌دهد.</li>
                <li>کاربران می‌توانند از طریق پشتیبانی (تیکت) مشکلات خود را گزارش دهند.</li>
              </ol>
            </section>

            {/* ✅ بخش جدید: صرف هزینه‌ها و غیرانتفاعی بودن */}
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex gap-3 items-start">
              <Info size={24} className="text-green-700 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-green-800 text-sm leading-relaxed text-justify">
اداره‌یِ این مؤسسه و فعالیت هیات‌مدیره به صورت غیرانتفاعی است، و کلیه‌یِ مبالغ پرداخت‌شده 
از سوی کاربران تحت عناوین مختلف از قبیل خرید محصولات دیجیتال، 
کمکهای مالی، کارتهای هدیه، و ... صرف توسعه‌یِ فنی 
و منابع انسانی این مجموعه در راستای ترویج بیشتر آراء و آثار مصطفی ملکیان خواهد شد.

                </p>
              </div>
            </div>

            <section className="bg-gray-50 p-4 rounded-lg">
              <p className="text-xs text-gray-500">
                آخرین به‌روزرسانی: ۱۴۰۵/۰۳/۲۰<br />
                این قوانین ممکن است به‌روز شوند و اطلاع‌رسانی در اپلیکیشن انجام خواهد شد.
              </p>
            </section>
          </div>

          <div className="mt-6">
            <Link to="/profile" className="block w-full text-center bg-gray-200 text-gray-700 py-2 rounded-lg hover:bg-gray-300 transition">
              بازگشت به پروفایل
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesPage;